import { TimePicker } from "antd";
import React from "react";
import { Form } from "../../atoms";
const format = "HH:mm";
interface IInputTimeRangeFieldProps {
  label: string | React.ReactElement;
  rules?: any[];
  name: string | any[];
  placeholder?: string;
  style?: any;
  initialValue?: any;
  className?: string;
  bordered?: boolean;
  minuteStep?: number;
  disabled?: boolean;
}

export const InputTimeRangeField: React.FC<IInputTimeRangeFieldProps> = ({
  label,
  rules,
  name,
  placeholder,
  style,
  className,
  initialValue,
  bordered = true,
  minuteStep = 5,
  disabled,
}) => (
  <Form.Item
    label={label}
    name={name}
    rules={rules}
    className={className}
    initialValue={initialValue}
    style={style}
  >
    <TimePicker.RangePicker
      bordered={bordered}
      style={style}
      format={format}
      minuteStep={minuteStep}
      disabled={disabled}
    />
  </Form.Item>
);
